import { motion } from "framer-motion";
import { Zap, ShieldCheck, Users, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { icon: Zap, t: "Internet Cepat", d: "Akses lancar untuk semua kebutuhan digital", g: "from-amber-400 to-orange-600", r: "ring-amber-100" },
  { icon: ShieldCheck, t: "Stabil & Andal", d: "Menggunakan teknologi terbaru (Fiber & Satelit)", g: "from-emerald-400 to-teal-600", r: "ring-emerald-100" },
  { icon: Users, t: "Harga Terjangkau", d: "Pilihan paket sesuai kebutuhan Anda", g: "from-rose-400 to-red-600", r: "ring-rose-100" },
  { icon: MapPin, t: "Jangkauan Luas", d: "Hadir di kota hingga daerah terpencil", g: "from-sky-400 to-blue-700", r: "ring-sky-100" },
];

export const Why = () => (
  <section id="tentang" data-testid="why-section" className="relative bg-gradient-to-b from-white to-sky-50/70 pt-10 pb-28">
    <div className="max-w-[1320px] mx-auto px-5 lg:px-10 grid lg:grid-cols-[300px_1fr] gap-12 items-start">
      <Reveal>
        <p className="font-display text-xl font-bold text-vnavy">Mengapa Memilih</p>
        <h2 className="font-display text-3xl font-extrabold text-gradient leading-tight">VISION MEGA NETWORK?</h2>
        <span className="block w-12 h-1 rounded-full bg-gradient-to-r from-vblue to-sky-400 mt-4" />
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-10">
        {ITEMS.map((it, i) => (
          <Reveal key={it.t} delay={i * 0.08} className={`text-center px-4 ${i ? "lg:border-l border-sky-200" : ""}`}>
            <motion.div whileHover={{ rotate: -8, scale: 1.08 }} className={`mx-auto w-16 h-16 rounded-full bg-gradient-to-br ${it.g} text-white grid place-items-center shadow-[0_14px_30px_-10px_rgba(11,42,138,0.6)] ring-4 ${it.r}`}>
              <it.icon size={28} />
            </motion.div>
            <h3 data-testid={`why-${i}`} className="font-display font-bold text-vnavy mt-4 text-lg">{it.t}</h3>
            <p className="text-sm text-slate-600 mt-1">{it.d}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

const WORDS = ["Internet Rumah", "WiFi Bisnis", "Fiber Optik", "Satelit", "Solusi Jaringan", "Internet Murah Kalimantan Barat"];

export const Marquee = () => (
  <div data-testid="marquee" className="relative bg-vnavy py-3 overflow-hidden border-y border-white/10">
    <div className="marquee-track flex w-max gap-6">
      {[...WORDS, ...WORDS, ...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className="flex items-center gap-6 font-display font-extrabold text-lg sm:text-2xl whitespace-nowrap">
          <span className={i % 2 ? "text-sky-300" : "text-white"}>{w}</span>
          <span className="w-2 h-2 rounded-full bg-sky-400 shadow-[0_0_12px_3px_rgba(56,189,248,0.7)]" />
        </span>
      ))}
    </div>
  </div>
);
